import { Injectable } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import {
  CadViewerDialogComponent,
  CadViewerDialogData,
} from 'src/app/components/cad-viewer/cad-viewer-dialog/cad-viewer-dialog.component';

@Injectable({ providedIn: 'root' })
export class CadViewerDialogService {
  constructor(private dialog: MatDialog) {}

  open(data: CadViewerDialogData): MatDialogRef<CadViewerDialogComponent> {
    return this.dialog.open(CadViewerDialogComponent, {
      data,
      width: '96vw',
      maxWidth: '96vw',
      height: '92vh',
      panelClass: 'cad-viewer-dialog-panel',
      autoFocus: false,
    });
  }
}
